const initialState = {
  member: "",
};

export const LOAD_PW_DATA = "LOAD_PW_DATA";
export const loadDataAction = () => ({
  type: LOAD_PW_DATA,
});

export const LOAD_DATA_SUCCESS = "LOAD_DATA_SUCCESS";
export const loadDataSuccessAction = (data) => ({
  type: LOAD_DATA_SUCCESS,
  payload: data,
});

export default function settingPasswordReducer(state = initialState, action) {
  const { type, payload, error } = action;

  console.log("settingPasswordReducer = type", type, "payload", payload);

  switch (type) {
    case LOAD_PW_DATA:
      return {
        ...state,
      };
    case LOAD_DATA_SUCCESS:
      return {
        ...state,
        member: payload,
      };
    default:
      return state;
  }
}
